import React from "react";
import PropTypes from "prop-types";
import { AlertCircle, Tag, X } from "lucide-react";

import Button from "../ui/Button";
import Typography from "../ui/Typography";

export default function ArchiveSearchTagBar({
  indexStatus,
  isSearchActive,
  popularTags,
  prefetchIndex,
  removeTag,
  selectTag,
  selectedTagDetails,
}) {
  return (
    <div className="archive-discovery__tags">
      {selectedTagDetails.map((tag) => (
        <Button
          key={tag.slug}
          type="button"
          variant="filter-active"
          size="sm"
          className="min-h-9 gap-2 px-3 py-1.5 text-body-small"
          onClick={() => removeTag(tag.slug)}
        >
          {tag.tag}
          <X className="h-3.5 w-3.5" aria-hidden="true" />
        </Button>
      ))}
      {!isSearchActive && popularTags.map((tag) => (
        <Button
          key={tag.slug}
          type="button"
          variant="filter"
          size="sm"
          className="min-h-9 gap-2 px-3 py-1.5 text-body-small"
          onPointerEnter={prefetchIndex}
          onClick={() => selectTag(tag.slug)}
        >
          <Tag className="h-3.5 w-3.5" aria-hidden="true" />
          {tag.tag}
        </Button>
      ))}
      {indexStatus === "error" && (
        <Typography variant="caption" className="inline-flex items-center gap-2 text-muted-foreground">
          <AlertCircle className="h-3.5 w-3.5" aria-hidden="true" />
          Tags unavailable
        </Typography>
      )}
    </div>
  );
}

ArchiveSearchTagBar.propTypes = {
  indexStatus: PropTypes.string.isRequired,
  isSearchActive: PropTypes.bool.isRequired,
  popularTags: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
  })).isRequired,
  prefetchIndex: PropTypes.func.isRequired,
  removeTag: PropTypes.func.isRequired,
  selectTag: PropTypes.func.isRequired,
  selectedTagDetails: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
  })).isRequired,
};
